import { render, staticRenderFns } from "./TaskListActions.vue?vue&type=template&id=6c5bb770&scoped=true"
import script from "./TaskListActions.vue?vue&type=script&lang=js"
export * from "./TaskListActions.vue?vue&type=script&lang=js"
import style0 from "./TaskListActions.vue?vue&type=style&index=0&id=6c5bb770&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5bb770",
  null
  
)

export default component.exports